import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import appSliceReducer from "./appSlice";
import homepageSliceReducer from "./homepageSlice";
import referralRegistrationSliceReducer from "./components/registerPatient/referralRegistrationSlice";
import registrationSliceReducer from "./components/registerPatient/registrationSlice";
import dataGridSliceReducer from "./components/shared/dataGrid/dataGridSlice";
import reportSearchFilterSliceReducer from "./components/shared/filters/reportSearchFilterSlice";
// Separate persist config for registration state using session storage
const registrationPersistConfig = {
  key: "registration",
  storage: sessionStorage,
};

// Wrap the registration reducer with its own persist config
const persistedRegistrationReducer = persistReducer(
  registrationPersistConfig,
  registrationSliceReducer
);

const rootReducer = combineReducers({
  app: appSliceReducer,
  homepageState: homepageSliceReducer,
  reportSearchFilterState: reportSearchFilterSliceReducer,
  registrationState: persistedRegistrationReducer,
  referralRegistrationState: referralRegistrationSliceReducer,
  dataGridState: dataGridSliceReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
